<template>
  <v-menu v-model="menuOpen" :nudge-width="100" :close-on-content-click="true">
    <template #activator="{ props }">
      <v-btn
        variant="text"
        density="comfortable"
        color="primary"
        icon="mdi-dots-vertical"
        v-bind="props"
        @click.stop.prevent
      >
      </v-btn>
    </template>
    <template #default>
      <v-list density="compact">
        <ContextMenuOption
          v-for="(option, key) in options"
          :key="key"
          :option="option"
          @action-executed="closeMenu"
        />
        <v-divider v-if="options.length > 0 && logoutButton" />
        <LogOutButton v-if="logoutButton" />
      </v-list>
    </template>
  </v-menu>
</template>

<script>
import { defineComponent, ref } from "vue";
import ContextMenuOption from "./ContextMenuOption.vue";
import LogOutButton from "./LogOutButton.vue";

export default defineComponent({
  name: "ContextMenu",
  components: {
    ContextMenuOption,
    LogOutButton,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    logoutButton: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const menuOpen = ref(false);

    const closeMenu = () => {
      menuOpen.value = false;
    };

    return {
      menuOpen,
      closeMenu,
    };
  },
});
</script>
